import { Switch } from 'antd'
import { URLBACK } from '../../assets/urls'
import { Organization } from '../../reducers/organizationReducer'
import { globalUpdateCompanySetting } from '../../utils'

export const UpdateStatusActionAndDeployment = async (setting, status, type, axios) => {
  const newStatus = status.join(',')
  if (type === 'action') {
    try {
      await axios.put(`settings/${setting.id}`, {
        githubActionStatusNotifications: newStatus,
      })
    } catch (e) {
      console.log('Error, please contact support :', e)
    }
  } else if (type === 'deployment') {
    try {
      await axios.put(`settings/${setting.id}`, {
        githubDeploymentStatusNotifications: newStatus,
      })
    } catch (e) {
      console.log('Error, please contact support :', e)
    }
  }
}

export async function fetchSlackChannelsAndUpdateReducer({
  organization,
  user,
  axios,
  dispatch,
  setLoading,
}) {
  // If we already have Slack channels, no need to fetch
  if (organization.slackChannels?.length > 0) {
    if (typeof setLoading === 'function') {
      setLoading(false)
    }
    return
  }

  // If user is autoAssignReviewer, skip Slack channel fetching
  if (user?.providerName === 'autoAssignReviewer') {
    if (typeof setLoading === 'function') {
      setLoading(false)
    }
    return
  }

  // If we don't have required data, set loading to false and return
  if (!organization.id || !user?.id) {
    if (typeof setLoading === 'function') {
      setLoading(false)
    }
    return
  }

  // Set loading to true when we start fetching
  if (typeof setLoading === 'function') {
    setLoading(true)
  }

  let i = 0
  let slackChannelsLength = 0

  while (slackChannelsLength === 0 && i < 200) {
    i += 1
    await new Promise((r) => setTimeout(r, 5000))

    if (process.env.NODE_ENV !== 'development') {
      try {
        const res = await axios.get(
          `${URLBACK}conversations/get-all-conversations?organization=${organization.id}&_limit=-1&userId=${user.id}`,
        )
        if (res.data?.length > 0) {
          dispatch(
            Organization.actions.setData({
              slackChannels: res.data,
            }),
          )
          slackChannelsLength = res.data.length
          if (typeof setLoading === 'function') {
            setLoading(false)
          }
          return // Exit the loop when successful
        }
        // If we get an empty response, we should still set loading to false
        // but continue trying for a few more attempts
        if (i >= 3) {
          // Try up to 3 times (15 seconds total)
          if (typeof setLoading === 'function') {
            setLoading(false)
          }
          return
        }
      } catch (error) {
        console.log('Error getting slack channels', error)
        // Don't continue the loop on error, just set loading to false
        if (typeof setLoading === 'function') {
          setLoading(false)
        }
        return
      }
    } else {
      if (typeof setLoading === 'function') {
        setLoading(false)
      }
      return
    }
  }

  // Set loading to false if we exit the loop without success
  if (typeof setLoading === 'function') {
    setLoading(false)
  }
}

export const AutoAssignReviewerSetting = ({
  // default true for AutoAssignReviewerSetting
  orgIsPremium = true,
  setting,
  setIsModalPaywallVisible,
  axios,
  dispatch,
}) => (
  <div className="ml-10">
    <div className="relative" style={{ width: '100%' }}>
      <div className="flex justify-between">
        <p className="">
          Enable auto reviewer assignement for GitLab merge requests.
          <br />
          By default, Axolo will invite 2 reviewers per CODEOWNERS line. You can set
          Axolo's behavior by adding an integer at the end of each line. Learn more in{' '}
          <a
            href="https://axolo.co/docs/gitlab/auto-assignement-for-reviewers"
            target="_blank"
            rel="noreferrer"
          >
            our documentation
          </a>
          .
        </p>
        <Switch
          disabled={!orgIsPremium}
          checked={setting?.autoAssignReviewer}
          onClick={() => {
            if (orgIsPremium) {
              globalUpdateCompanySetting({
                key: 'autoAssignReviewer',
                value: !setting?.autoAssignReviewer,
                setting,
                axios,
                dispatch,
              })
            }
          }}
        />
      </div>
      {!orgIsPremium && (
        <div
          className="absolute bottom-0 left-0 right-0 top-0"
          onClick={() => {
            setIsModalPaywallVisible(true)
          }}
          style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
        />
      )}
    </div>
    <div className=" mt-10 flex flex-col">
      <p className="text-center !text-xs">
        Some examples on how to write your CODEOWNERS file. <br />
        If you have not any CODEOWNERS file yet, please{' '}
        <a
          href="https://docs.gitlab.com/ee/user/project/codeowners/"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {' '}
          follow the official documention
        </a>
        .
      </p>
      <div className="flex justify-center">
        <img
          src="/images/codeowner-screen.png"
          alt="codeowners screenshot"
          className="max-w-lg"
        />
      </div>
    </div>
  </div>
)
